<template>
  <div class="edit-winner-dropdown">
    <button
      v-if="winnerPresent"
      @click="removeWinner"
      class="btn all-records p-0"
      >
      {{I18n.t(`employees.live_auctions.remove_winner`)}}
    </button>
    <button
      v-if="!winnerPresent"
      @click="toggleShowDropdown()"
      class="edit-winner-dropdown-btn"
      >
      <span class="icon icon-arrow-bottom"></span>
    </button>
    <div
      id="myDropdown"
      class="edit-winner-dropdown-content"
      :class="{ 'd-block': showDropdown }"
      >
      <autocomplete
        url="/api/v1/employees/users/search"
        param="query"
        :min="3"
        anchor="attributes.lastname"
        :process="getResponseData"
        :onShouldRenderChild="renderUser"
        :onSelect="(data) => setNewWinner(data)"
      />
    </div>
  </div>
</template>

<script>
  import Autocomplete from 'vue2-autocomplete-js';

  export default {
    name: 'EditAuctionWinner',
    data() {
      return {
        newWinner: {},
        showDropdown: false,
        winnerPresent: this.winnerAssigned,
      };
    },
    props: {
      auctionsCatalogId: {
        type: String,
        required: true,
      },
      auctionId: {
        type: String,
        required: true,
      },
      winnerAssigned: {
        type: Boolean,
        required: true,
      },
    },
    components: {
      Autocomplete,
    },
    methods: {
      setNewWinner(data) {
        if (typeof data !== 'undefined') {
          this.newWinner.id = data.id;
          this.newWinner.firstname = data.attributes.firstname;
          this.newWinner.lastname = data.attributes.lastname;
          this.winnerPresent = true;
          this.toggleShowDropdown();
          this.$emit('update-winner', this.newWinner);
        }
      },
      removeWinner() {
        this.newWinner = {};
        this.winnerPresent = false;
        this.toggleShowDropdown();
        this.$emit('update-winner', this.newWinner);
      },
      getResponseData(obj) {
        return obj.data;
      },
      renderUser(data) {
        return `
          <span>
            ${data.attributes.firstname} ${data.attributes.lastname} (${data.attributes.email})
          </span>
        `;
      },
      toggleShowDropdown() {
        this.showDropdown = !this.showDropdown;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/edit_auction_winner.vue?33a842e6